// Left-rail control panel used by Roadmap (composition controls +
// view-mode toggle) and Timeline (Activity feed). Scrolls
// independently from the main matrix and collapses to a thin gutter
// the user can re-expand.

import { useState, type ReactNode } from 'react';

export function ControlPanel({
  title,
  children,
  defaultCollapsed = false,
}: {
  title: string;
  children: ReactNode;
  defaultCollapsed?: boolean;
}) {
  const [collapsed, setCollapsed] = useState(defaultCollapsed);
  return (
    <aside
      className={`snap-control-panel${collapsed ? ' is-collapsed' : ''}`}
      aria-label={title}
    >
      <div className='snap-control-panel__header'>
        {collapsed ? null : (
          <h2 className='snap-control-panel__title'>{title}</h2>
        )}
        <button
          type='button'
          className='snap-control-panel__toggle'
          onClick={() => setCollapsed(v => !v)}
          aria-label={collapsed ? `Expand ${title}` : `Collapse ${title}`}
          title={collapsed ? `Expand ${title}` : `Collapse ${title}`}
        >
          <svg
            viewBox='0 0 24 24'
            fill='none'
            stroke='currentColor'
            strokeWidth='1.75'
            strokeLinecap='round'
            strokeLinejoin='round'
            aria-hidden
          >
            {collapsed ? (
              /* Right-rail panel — when collapsed, the chevron points
               * left to signal "click to pull the panel open." */
              <path d='m15 18-6-6 6-6' />
            ) : (
              /* When expanded, pointing right signals "click to push
               * the panel back to the gutter." */
              <path d='m9 18 6-6-6-6' />
            )}
          </svg>
        </button>
      </div>
      {collapsed ? null : (
        <div className='snap-control-panel__body'>{children}</div>
      )}
    </aside>
  );
}
